export default __webpack_public_path__ + "static/media/50.f2048f2e.gif";